import { createRouter, createWebHistory } from 'vue-router'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import AdminHeader from '../components/admin/AdminHeader.vue'
import AdminHero from '../components/admin/AdminHero.vue'
import AdminLogin from '../views/admin/Login.vue'

// Views
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Services from '../views/Services.vue'
import Contact from '../views/Contact.vue'
import Gallery from '../views/Gallery.vue'
import NotFound from '../views/NotFound.vue'
import Privacy from '../views/Privacy.vue'
import Terms from '../views/Terms.vue'
import Imprint from '../views/Imprint.vue'
import Attributions from '../views/Attributions.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/services',
        name: 'services',
        component: Services
    },
    {
        path: '/gallery',
        name: 'gallery',
        component: Gallery
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Privacy
    },
    {
        path: '/terms',
        name: 'terms',
        component: Terms
    },
    {
        path: '/imprint',
        name: 'imprint',
        component: Imprint
    },
    {
        path: '/attributions',
        name: 'attributions',
        component: Attributions
    },
    {
        path: '/admin/login',
        name: 'admin-login',
        component: AdminLogin,
        meta: { requiresAuth: false }
    },
    {
        path: '/admin/dashboard',
        name: 'admin-dashboard',
        component: AdminDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/header',
        name: 'admin-header',
        component: AdminHeader,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/hero',
        name: 'admin-hero',
        component: AdminHero,
        meta: { requiresAuth: true }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

// Navigation guard for admin routes
router.beforeEach((to, from, next) => {
    // Check if the route requires authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // Check if user is logged in
        const adminUser = sessionStorage.getItem('adminUser')
        if (!adminUser) {
            // Redirect to login page if not authenticated
            next({
                path: '/admin/login',
                query: { redirect: to.fullPath }
            })
        } else {
            // Allow access to protected route
            next()
        }
    } else {
        // Allow access to public routes
        next()
    }
})

// Error handling
router.onError((error) => {
    console.error('Router error:', error)
    console.error('Error details:', error.message, error.stack)
    // Don't redirect - let the error handler deal with it
    // This prevents infinite redirect loops
})

// Export route-to-SEO mapping for use in App.vue
export const seoKeyMap = {
    'home': 'home',
    'about': 'about',
    'services': 'services',
    'contact': 'contact',
    'privacy': 'privacy',
    'terms': 'terms',
    'imprint': 'imprint',
    'gallery': 'home', // Use home SEO for gallery if no specific SEO defined
    'attributions': 'home', // Use home SEO for attributions if no specific SEO defined
    'not-found': 'home' // Use home SEO for 404 page
}

export default router 